module.exports = __webpack_public_path__ + "img/600.dcada371.jpg";